import { DataPage } from "@xbs/muon";
import { getDefaultFormats } from "../helpers/format";
import { getCellInfo, getCellIds, isURL } from "../helpers/main";
import { IAction, IActionConfig } from "../types";
declare const dhx: any;

export class InsertLink implements IAction {
	public config: IActionConfig;
	private _page: DataPage;

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page as DataPage;
	}

	do() {
		const { cell, val, grid } = this.config;
		if (!cell) return;
		const { row, col } = getCellIds(cell, grid);
		const spreadsheet = this.config.spreadsheet;
		if (spreadsheet?.isLocked(cell)) {
			return;
		}
		const meta = getCellInfo(cell, this._page, grid);
		let { css, format } = meta;
		if (!format) {
			format = getDefaultFormats().filter(i => i.id === "common")[0];
		}

		this.config.prev = meta;

		if (val) {
			let { text, href } = val;
			text = text.trim()
			this._page.setCell(row, col, {
				value: text || href,
				link: {...val, text},
				css: `dhx_spreadsheet_link ${css || ""}`,
				format,
			});
		} else {
			this._page.setCell(row, col, {
				link: null,
				css: css?.split("dhx_spreadsheet_link ").join(""),
				format,
			});
		}
		this.config.grid?.paint();
	}

	undo() {
		const { cell, grid, groupAction } = this.config;
		if (!cell) return;
		const { row, col } = getCellIds(cell, grid);
		const { value = "", css = "", link = null } = this.config.prev;
		if (groupAction) {
			this._page.setCell(row, col, { link });
		} else {
			this._page.setCell(row, col, { value, css, link });
		}
		grid?.paint();
	}
}
